<script>
import ChannelMixin from "./channel-mixin"
import ChannelPostMenu from "./channel-post-menu.vue"
import ImageViewer from "./image-viewer.vue"

export default {
  name: 'ChannelActivity',
  mixins: [ChannelMixin],
  components: {ChannelPostMenu, ImageViewer},

  data() {
    return {
      pinnedOnly: true,
      reverseOrder: false,
      postsPerPage: 5,
      showAll: false,
    }
  },

  computed: {
    mmtoken() {
      return this.$storage.getToken()
    },
    pinnedPostIds() {
      if (this.showAll)
        return this.orderedPostIds
      return this.orderedPostIds.slice(0, this.postsPerPage)
    }
  }
}
</script>

<template>
<span>
  <div v-if="mmtoken && !isOffline" ref="postList" class="c-flex">
    <div>
      <div v-for="pid in pinnedPostIds" :key="pid" class="mb-3"
      >
        <channel-post-menu
         v-if="posts[pid].showMenu"
         :post="posts[pid]"
         :likes-only="true"
         @like="reactToPost($event, 'heart')"
         @thumbsup="reactToPost($event, '+1')"
        />

        <div class="card bg-primary mb-1 c-border-radius-25">
            <div @click="onPostClick(pid, $event)" class="d-flex card-body">
            <img :src="avatars[posts[pid].user_id]" class="avatar" :alt="avatars[posts[pid].username]" />
            <div class="flex-grow-1 ms-2">
                <div>
                <div>
                    <b v-if="posts[pid].username">{{ userFullName(pid) }}:</b><span class="text-muted">&nbsp;{{ getFormatedDate(posts[pid].created_at) }}</span>
                </div>
                <div class="c-post" v-html="convert2Html(posts[pid].message)"></div>
                </div>
                <img class="img-thumbnail c-post-img" v-for="(image, idx) in postImages[pid]" :key="image.src" :src="image.src" :alt="image.name" @click.stop="openImageViewer(postImages[pid], idx)" />
                <div v-if="postFiles[pid]">
                  <a v-for="file in postFiles[pid]" :key="file.src" :href="file.src" target="_blank" class="d-block">
                    <i class="fas fa-paperclip"></i> {{ file.name }}
                  </a>
                </div>
            </div>
            </div>
        </div>
        <div v-if="pid in postReactions">
            <button v-for="(v, k) in postReactions[pid]" :key="k" class="btn btn-sm btn-outline-light me-1"
            @click.prevent="reactToPost(pid, k)"
            >
            <span style="color: black">{{ emojis[k] || k }}&nbsp;{{ v.size }}</span>
            </button>
        </div>
      </div>

      <div class="text-center">
        <span v-if="!showAll" class="btn" @click.prevent="showAll = true"><i class="fas fa-chevron-down"></i></span>
      </div>

    </div>
  </div>

  <image-viewer v-if="viewerImages" :images="viewerImages" :start-index="viewerIndex" @close="closeImageViewer" />

  <div v-else-if="isOffline" class="text-center card bg-primary">
    <div class="card-body">
      <h3>Keine Serververbindung</h3>
    </div>
  </div>

  <div v-else class="text-center card bg-primary">
    <div class="card-body">
        <h3><a href="/accounts/login?next=/">Login</a> erforderlich, um den <b>Activity-Stream</b> anzeigen zu können.</h3>
    </div>
  </div>
</span>
</template>

<style scoped>
.c-border-radius-25 { border-radius: .25rem}

.c-flex {
  flex: 1
}
.avatar {
  height:30px;
  width:30px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}
.c-post-img {
  max-height: 40vh;
  cursor: pointer;
}
</style>